import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

interface CreateProjectRolePopoverProps {
  onSubmit: () => void
  disabledSubmitButton: boolean
  excludeEmployeeIds: number[]
  selectedEmployees: EmployeeForSelectFragmentNoAccess[]
  onSelectEmployees: (employees: EmployeeForSelectFragmentNoAccess[]) => void
}

const CreateProjectRolePopover = ({
  onSubmit,
  disabledSubmitButton,
  excludeEmployeeIds,
  selectedEmployees,
  onSelectEmployees,
}: CreateProjectRolePopoverProps) => {
  const [open, toggle] = useToggle(false)

  const onClickPopover = () => {
    onSubmit()
    toggle(!open)()
  }

  const onSubmitPopover = () => {
    onSubmit()
    toggle(false)()
  }

  const buttonTitle = () => {
    switch (selectedEmployees.length) {
      case 0:
        return i18n.t(
          'project_management.modals.create_project.wizard.step_two.select_button.zero_selected'
        )
      case 1:
        return i18n.t(
          'project_management.modals.create_project.wizard.step_two.select_button.one_selected'
        )
      default:
        return i18n.t(
          'project_management.modals.create_project.wizard.step_two.select_button.other_selected',
          { counter: selectedEmployees.length }
        )
    }
  }

  return (
    <Box paddingTop="s24" style={{ display: 'inline' }}>
      <PopoverMenu type="dialog" onClick={onClickPopover} open={open}>
        <PopoverMenu.Trigger>
          <Button iconName="add" type={'secondary'}>
            {i18n.t('common.add')}
          </Button>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="right" align="center" width="s360">
          <Box paddingX="s12">
            <EmployeeSelector
              alwaysOpen
              multiple
              excludeCurrentEmployee
              excludeIds={excludeEmployeeIds}
              onSelect={onSelectEmployees}
              value={selectedEmployees}
            />
            <Box paddingTop="s16">
              <Button type="primary" onClick={onSubmitPopover} disabled={disabledSubmitButton}>
                {buttonTitle()}
              </Button>
            </Box>
          </Box>
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}

export default CreateProjectRolePopover
